import { render } from "./TripPlannerRouteDetails.vue?vue&type=template&id=c5a27fae&scoped=true"
import script from "./TripPlannerRouteDetails.vue?vue&type=script&lang=js"
export * from "./TripPlannerRouteDetails.vue?vue&type=script&lang=js"

import "./TripPlannerRouteDetails.vue?vue&type=style&index=0&id=c5a27fae&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a27fae"]])

export default __exports__